import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-videoDisplayer',
  templateUrl: './videoDisplayer.component.html',
  styleUrls: ['./videoDisplayer.component.css']
})
export class VideoDisplayerComponent implements OnInit {

  @Input('withButton') withButton: Boolean = false;

  @Input('loading') loading: Boolean = false;

  @Input('size') size: String = "big";

  @Input('width') width: number = 540;

  @Input('height') heigth: number = 380;

  @ViewChild("video", { static: false })
  public video: ElementRef;

  @ViewChild("canvas", { static: false })
  public canvas: ElementRef;

  public captures: Array<any> = [];

  public error: String = "";

  public activated: Boolean = false;

  private errorDisplayerMap: Map<Number, String> = new Map(
    [
      [8, "No se encontro dispositivo de video instalado en el equipo"],
      [0, "No se otorgaron permisos para acceder a los dispositivos"]
    ]
  );

  @Output() capturesE: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  public constructor() {
  }

  public ngOnInit() { }

  public ngAfterViewInit() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
        this.activated = true;
      }).catch(e => {
        this.error = this.translateError(e);
      });
    }
  }

  translateError(e: any): String {
    return this.errorDisplayerMap.has(e.code) ? this.errorDisplayerMap.get(e.code) : 'Ha ocurrido un error inesperado';
  }

  public capture() {
    var context = this.canvas.nativeElement.getContext("2d").drawImage(this.video.nativeElement, 0, 0, this.width, this.heigth);
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
    this.capturesE.emit(this.captures);
  }

}
